<template>
  <div>
    <datatable
      title="Admin Recommendations"
      @delete="deleteRecommendation"
      @create="createSkill"
      @edit_click="editClick"
      :fields="fields"
      :response="recommendations"
    ></datatable>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'admin-recommendations',
  created: function () {
    this.fetchRecommendations()
  },
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'Content',
          value: 'content'
        },
        {
          name: 'Resource Type',
          value: 'resource_type'
        },
        {
          name: 'Resource Id',
          value: 'resource_id'
        },
        {
          name: 'Name',
          value: 'name'
        }
      ]
    }
  },
  computed: {
    ...mapState('recommendations', ['recommendations'])
  },
  methods: {
    deleteRecommendation (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.resource_type + ' recommendation',
        item_name: delete_data.resource_type + ' recommendation',
        method: 'deleteServiceRecommendation',
        method_params: { id: delete_data.id }
      })
    },
    createSkill () {
      this.create({
        designator: 'admin-recommendations-form-modal',
        component_name: 'ServiceRecommendation',
        is_create: true,
        modal_title: 'Create new Recommendation'
      })
    },
    editClick (data) {
      this.create({
        designator: 'admin-recommendations-form-modal',
        component_name: 'ServiceRecommendation',
        modal_title: 'Edit Recommendation',
        id: data.id
      })
    },
    ...mapMutations('modals', ['create']),
    ...mapActions('recommendations', ['fetchRecommendations'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
<style scoped></style>
